export const colorThemes = [
	'slate',
	'gray',
	'stone',
	'red',
	'orange',
	'amber',
	'yellow',
	'lime',
	'green',
	'emerald',
	'teal',
	'cyan',
	'sky',
	'blue',
	'indigo',
	'violet',
	'purple',
	'fuchsia',
	'pink',
	'rose',
]

export type ColorTheme = (typeof colorThemes)[number]

const variants = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950] as const

export function getThemeVariables(colorTheme: string): string | undefined {
	if (colorTheme && colorThemes.includes(colorTheme as ColorTheme)) {
		return variants
			.map((variant) => `--color-primary-${variant}: var(--color-${colorTheme}-${variant})`)
			.join(';')
	}
}

export function applyColorTheme(
	colorTheme: string,
	element: HTMLElement = document.documentElement,
): void {
	const themeVariables = getThemeVariables(colorTheme)
	if (themeVariables) {
		element.style.cssText += themeVariables
	}
}
